import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DatevWizardState} from '../../+store/datev-wizard.state';
import {DatevWizardConfigDetailsState} from './datev-wizard-config-details.state';
import {ErrorEventEntitiesSelectors} from '../../../../../store/error-event-entities/error-event-entities.selectors';
import {ExportJobDTO, ExportJobPageDTO} from '../../../../../openapi/export-openapi';


export class DatevWizardConfigDetailsSelectors {

  private static readonly _feature = createFeatureSelector<DatevWizardState>('wizard');

  private static readonly _slice = createSelector(
    this._feature,
    (state): DatevWizardConfigDetailsState => state.datevWizardConfigDetails,
  );

  /**
   * Gibt an, ob gerade eine Verbindung zu DATEV hergestellt wird.
   */
  public static readonly isConnecting = createSelector(
    this._slice,
    (state) => state.isConnecting,
  );

  /**
   * Gibt an, ob gerade eine Verbindung zu DATEV getrennt wird.
   */
  public static readonly isDisconnecting = createSelector(
    this._slice,
    (state) => state.isDisconnecting,
  );

  /**
   * Gibt den Fehler zurück, der beim Verbinden aufgetreten ist.
   */
  public static readonly connectionError = createSelector(
    this._slice,
    (state) => state.connectionError,
  );

  /**
   * Gibt den Fehler zurück, der beim Trennen der Verbindung aufgetreten ist.
   */
  public static readonly disconnectionError = createSelector(
    this._slice,
    (state) => state.disconnectionError,
  );

  /**
   * Gibt an, ob gerade die Konfiguration gelöscht wird.
   */
  public static readonly isDeleting = createSelector(
    this._slice,
    (state) => state.isDeleting,
  );

  /**
   * Gibt den Fehler zurück, der beim Löschen aufgetreten ist.
   */
  public static readonly deletionError = createSelector(
    this._slice,
    (state) => state.deletionError,
  );

  /**
   * Gibt an, ob gerade die Export-Konfiguration aktualisiert wird.
   */
  public static readonly isUpdatingConfiguration = createSelector(
    this._slice,
    (state) => state.isUpdatingConfiguration,
  );

  /**
   * Gibt den Fehler zurück, der beim Aktualisieren aufgetreten ist.
   */
  public static readonly updateConfigurationError = createSelector(
    this._slice,
    (state) => state.updateConfigurationError,
  );

  /**
   * Gibt das Error-Events Page-Objekt zurück (mit IDs).
   */
  public static readonly errorEventsPage = createSelector(
    this._slice,
    (state) => state.errorEventsPage,
  );

  /**
   * Mappt die Job-IDs zu vollständigen DTOs und gibt ein vollständiges Page-Objekt zurück.
   * Kombiniert errorEventsPage (IDs + Pagination) mit errorEventEntities (DTOs).
   */
  public static readonly errorEventsPageWithDtos = createSelector(
    this.errorEventsPage,
    ErrorEventEntitiesSelectors.all,
    (page, allJobs): ExportJobPageDTO | undefined => {
      if (!page) return undefined;

      // Erstelle Map für schnelles Lookup
      const jobsById = new Map(allJobs.map(job => [job.id, job]));

      // Mappe IDs zu DTOs und filtere undefined
      const content = page.content
        .map(id => jobsById.get(id))
        .filter((job): job is ExportJobDTO => job !== undefined);

      return {
        content,
        pageable: page.pageable,
        totalElements: page.totalElements,
        elements: page.elements,
      };
    },
  );

}
